module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._m(0), " ", _vm._h('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadBottom),
      expression: "loadBottom"
    }],
    staticClass: "main-page news-list",
    staticStyle: {
      "padding-bottom": "60px"
    },
    attrs: {
      "infinite-scroll-disabled": "isGetting",
      "infinite-scroll-distance": "150"
    }
  }, [_vm._h('div', [_vm._h('ul', {
    staticClass: "list-group-item primary"
  }, [_vm._l((_vm.getPushInfo), function(item) {
    return _vm._h('li', {
      staticClass: "list-group"
    }, [_vm._h('div', {
      staticClass: "liner"
    }), " ", _vm._h('router-link', {
      staticClass: "group-link clearfix",
      attrs: {
        "to": item.contentType == 22 ? {
          path: '/user/center/NewsDetailInvitation/' + item.pushId
        } : {
          path: '/user/center/NewsDetail/' + item.pushId
        }
      }
    }, [_vm._h('span', {
      staticClass: "pull-left img-wrap small"
    }, [_vm._h('img', {
      staticClass: "pull-left",
      attrs: {
        "src": _vm.img_default,
        "width": "40"
      }
    })]), " ", _vm._h('span', {
      staticClass: "group-txt"
    }, [_vm._h('span', {
      staticClass: "block overhide"
    }, [_vm._h('cite', {
      staticClass: "pull-left font-16"
    }, [_vm._s(item.pushType == 1 ? '系统通知' : '消息通知')]), " ", _vm._h('span', {
      staticClass: "pull-right gray font-12"
    }, [_vm._s(item.pushDateString)])]), " ", _vm._h('cite', {
      staticClass: "con"
    }, [_vm._s(item.pushContent)])]), " ", (item.isRead == 0) ? _vm._h('i') : _vm._e()])])
  }), " ", _vm._l((_vm.getBroadInfo), function(item) {
    return _vm._h('li', {
      staticClass: "list-group"
    }, [_vm._h('div', {
      staticClass: "liner"
    }), " ", _vm._h('router-link', {
      staticClass: "group-link clearfix",
      attrs: {
        "to": {
          path: (item.contentType == 22 ? '/user/center/NewsDetailInvitation/' : '/user.center/NewsDetail/') + item.pushId
        }
      }
    }, [_vm._h('span', {
      staticClass: "img-wrap pull-left small"
    }, [_vm._h('img', {
      attrs: {
        "src": _vm.img_default,
        "width": "100%"
      }
    })]), " ", _vm._h('span', {
      staticClass: "group-txt"
    }, [_vm._h('span', {
      staticClass: "block overhide"
    }, [_vm._h('cite', {
      staticClass: "pull-left font-16"
    }, [_vm._s(item.pushType == 1 ? '系统通知' : '消息通知')]), " ", _vm._h('span', {
      staticClass: "pull-right gray font-12"
    }, [_vm._s(item.pushDateString)])]), " ", _vm._h('cite', {
      staticClass: "con"
    }, [_vm._s(item.pushContent)])]), " ", (item.field1 == 0) ? _vm._h('i') : _vm._e()])])
  })])])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript: window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["消息"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-6fa7fe87!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/user/NewsList.vue
// module id = 213
// module chunks = 1